import type { RedirectionRoute } from "./router-redirections.type";

import { useLocation } from "react-router";

import { useOrganizationContext } from "@/modules/organization/organization-context";

import { getRedirectionPath } from "./router-redirections.helper";

export const useGetRedirectionPath = (routes: RedirectionRoute[]) => {
  const location = useLocation();
  const { contextSlug, isLoading } = useOrganizationContext();

  const redirectPath = getRedirectionPath({
    routes,
    pathname: location.pathname,
    context: contextSlug,
  });

  const redirectTo = redirectPath
    ? redirectPath + location.search + location.hash
    : undefined;

  return {
    loading: isLoading,
    redirectTo,
  };
};
